import React from 'react'
import * as R from 'ramda'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { makeStyles, Typography } from '@material-ui/core'

import { getRangDate } from 'commons/date'
import { usePlace } from 'commons/usePlace'

import PlainText from 'app/componentV4/PlainText'
import SimpleDialog from 'app/componentV4/Dialog/SimpleDialog'

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiDialog-paper': {
      width: '90vw',
      padding: '2.5rem',
      [theme.breakpoints.up('sm')]: {
        width: '500px',
      },
      [theme.breakpoints.up('md')]: {
        width: '800px',
      },
    },
  },
}))

const VoucherDetail = (props) => {
  const { data, onClose, isOpen } = props
  const { startTime, endTime, translated } = data

  const place = usePlace()
  const classes = useStyles()
  const { formatMessage } = useIntl()

  return (
    <SimpleDialog
      id={'metrics-subscriber-list-with-tabs'}
      open={isOpen}
      title={
        <Typography className="text-primary text-20 font-medium flex items-center">
          {formatMessage({
            id: 'preview.voucher.dialog.title',
          })}
        </Typography>
      }
      onClose={onClose}
      className={classes.root}
    >
      <div className="space-y-10">
        <div className="my-10 flex items-center space-x-5">
          <img
            alt="logo-place-voucher-detail"
            src={place.info.logo}
            width={65}
            height={65}
            className="rounded-full"
          />
          <Typography className="text-primary text-18 font-normal">
            {R.prop('name', place)}
          </Typography>
        </div>
        <div className="space-y-5">
          <Typography className="text-primary text-20 font-medium">
            <PlainText text={R.prop('title', translated)} />
          </Typography>
          <Typography className="text-primary text-16 font-normal">
            <PlainText text={R.prop('body', translated)} />
          </Typography>
        </div>
        <div>
          <Typography className="text-primary text-14 font-medium flex items-center">
            {formatMessage({
              id: 'preview.voucher.valid.label',
            })}
          </Typography>
          <Typography className="text-primary text-14 font-normal flex items-center">
            {getRangDate(startTime, endTime)}
          </Typography>
        </div>
      </div>
    </SimpleDialog>
  )
}

const valuePropTypes = {
  startTime: PropTypes.string,
  endTime: PropTypes.string,
  translated: PropTypes.shape({
    body: PropTypes.string,
    title: PropTypes.string,
  }),
}
VoucherDetail.propTypes = {
  data: PropTypes.shape(valuePropTypes).isRequired,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
}
export default VoucherDetail
